import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

export default class FooterInfo extends Component {

	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-10% 0px -10% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	}  	
	render () {
		
		let block = this.props.block;
		let post = this.props.post;
	
		if (block) {
			
			let doInfo = false;
			if (post.footer_style === 'full' || post.footer_style === 'partial') {
				doInfo = true;
			}
						
		    return (
			    
			    <div className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
			    	{doInfo &&
				    	
					    <div className="c-footer__top">
							<div className="c-footer__top__left">
								
								{block.ftr_subscribe_form_id &&
									<div className="scope-subscription-form">
				    					<GravityForm
											backendUrl={document.location.origin + '/wp-json/virgon/v1/form'}
											formID={block.ftr_subscribe_form_id}
										/>
									</div>
								}
							</div>
							<div className="c-footer__top__right">
							
								<div className="c-footer__top__right__content">
									{block.ftr_phone && block.ftr_phone_url && block.ftr_email_address &&
										<p className="c-heading" dangerouslySetInnerHTML={{__html:'<a href="tel:' + block.ftr_phone_url + '">' + block.ftr_phone + '</a><br /><a href="mailto:' + block.ftr_email_address + '">' + block.ftr_email_address + '</a>'}}></p>
									}
								</div>
								
								<div className="c-footer__top__right__sec-content">
									{block.ftr_other_details &&
										<div className="scope-utility-text" dangerouslySetInnerHTML={{__html: block.ftr_other_details}}></div>
									}
								</div>
							</div>
						</div>
					
					}
					
					<div className="c-footer__bottom">
						<div className="c-footer__bottom__left">
							{block.ftr_privacy_url &&
								<Link to={{ pathname: block.ftr_privacy_url }} className="c-footer__menu-link">Privacy Policy</Link>
							}
							{block.ftr_disclaimer_url &&
								<Link to={{ pathname: block.ftr_disclaimer_url }} className="c-footer__menu-link">Disclaimer</Link>
							}
						</div>
						<div className="c-footer__bottom__right">
							<p className="c-footer__copyright" dangerouslySetInnerHTML={{__html: 'Copyright 2024'}}></p>
						</div>
					</div>
					
				</div>
									    
			)
			
		} else {
			
			return null;
		
		}
	}
}
